import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ChangeRequestService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            const body = response;
            return {
                success: true,
                data: body.data || [],
                pagination: body.pagination || {},
                uniqueValues: body.uniqueValues || {},
                message: body.message || 'Liste getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch item');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message || 'Kayıt oluşturuldu' };
        } catch (error) {
            throw this._handleError(error, 'Failed to create');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message || 'Kayıt güncellendi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to update');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Kayıt silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete');
        }
    }

    async submitForApproval(id, data) {
        try {
            const response = await this.api.submitForApproval(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to submit');
        }
    }

    async approve(id, data = {}) {
        try {
            const response = await this.api.approve(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to approve');
        }
    }

    async reject(id, data = {}) {
        try {
            const response = await this.api.reject(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to reject');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
